// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.slide-info-app-parent-superuser {    
    width: 416px;
    height: 960px;
    padding-left: 16px;
    padding-right:16px;
}

.slide-info-app-parent {    
  width: 416px;
  height: 35em;
  padding-left: 16px;
  padding-right:16px;
}

.slide-info-app-parent-case-info {    
  width: 640px;
  height: 960px;
  padding-left: 16px;
  padding-right:16px;
}

.slide-info-text {
    font-size: 12px;
}

.slide-info-details {
    background-color: rgba(0, 0, 0, 0);
}

.ant-table-placeholder {
    background-color: rgba(0, 0, 0, 0);
}

.slide-info-table {
  max-height: 320px;
  width: 416px;
  overflow-y: auto;
  background-color: rgba(0, 0, 0, 0);
}

.comment-info-table {
  max-height: 368px;
  width: 432px;
  /* overflow-y: auto; */
  background-color: rgba(0, 0, 0, 0);
}

.scroll {
  max-height: 800px;
  overflow-y: auto;
}

.slide-description-scroll {
  max-height: 320px;
  overflow-y: auto;
  white-space:pre-wrap;
}

.slide-description-scroll-superuser {
  max-height: 200px;
  overflow-y: auto;
  white-space:pre-wrap;
}

.scroll-slide-info {
  max-height: 560px;
  overflow-y: auto;
}`, "",{"version":3,"sources":["webpack://./src/asset/style/neoviewer/slide_info.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB","sourcesContent":[".slide-info-app-parent-superuser {    \n    width: 416px;\n    height: 960px;\n    padding-left: 16px;\n    padding-right:16px;\n}\n\n.slide-info-app-parent {    \n  width: 416px;\n  height: 35em;\n  padding-left: 16px;\n  padding-right:16px;\n}\n\n.slide-info-app-parent-case-info {    \n  width: 640px;\n  height: 960px;\n  padding-left: 16px;\n  padding-right:16px;\n}\n\n.slide-info-text {\n    font-size: 12px;\n}\n\n.slide-info-details {\n    background-color: rgba(0, 0, 0, 0);\n}\n\n.ant-table-placeholder {\n    background-color: rgba(0, 0, 0, 0);\n}\n\n.slide-info-table {\n  max-height: 320px;\n  width: 416px;\n  overflow-y: auto;\n  background-color: rgba(0, 0, 0, 0);\n}\n\n.comment-info-table {\n  max-height: 368px;\n  width: 432px;\n  /* overflow-y: auto; */\n  background-color: rgba(0, 0, 0, 0);\n}\n\n.scroll {\n  max-height: 800px;\n  overflow-y: auto;\n}\n\n.slide-description-scroll {\n  max-height: 320px;\n  overflow-y: auto;\n  white-space:pre-wrap;\n}\n\n.slide-description-scroll-superuser {\n  max-height: 200px;\n  overflow-y: auto;\n  white-space:pre-wrap;\n}\n\n.scroll-slide-info {\n  max-height: 560px;\n  overflow-y: auto;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
